import { ArbCommandResultDto } from '../../../revenue/shared/billing/dto/arb-command-result.dto';
import { ArbService } from '../../../revenue/shared/billing/arb.service';
import { Component, OnInit, OnDestroy, OnChanges, ViewChildren, QueryList, Input } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { ProfileService } from '../../shared/profile.service';
import { ProfileEditBillingComponent } from './profile-edit-billing.component';
import { Billing } from '../../../revenue/shared/billing/billing.model';
import { BillingService } from '../../../revenue/shared/billing/billing.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-profile-edit-billing-list',
  templateUrl: 'profile-edit-billing-list.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditBillingListComponent),
    CreateObjectValueValidationProvider(ProfileEditBillingListComponent),
  ],
    standalone: false
})
export class ProfileEditBillingListComponent extends ObjectValueAccessor<Array<Billing>> implements OnChanges {
  @Input() profileId: number;
  @ViewChildren(ProfileEditBillingComponent) _billingComponents: QueryList<ProfileEditBillingComponent>;

  showInactive = false;
  loading = false;
  billingToView: Billing;
  selectedIndex = 0;

  public constructor(
    private _billingService: BillingService,
    private _profileService: ProfileService,
    private _arbService: ArbService,
    private _notificationService: NotificationService
  ) {
    super([], false);
  }

  ngOnChanges() {
    this.loadBillings();
  }

  addBilling() {
    const today = new Date();
    const billing = {} as Billing;
    billing.ProfileId = this.profileId;
    billing.AnchorMonth = today.getMonth() + 1;
    billing.AnchorDay = 1;
    billing.StartingYear = today.getFullYear();
    billing.BillingCycle = 'Every 12 Months';
    billing.UnitPrice = 0;
    billing.Quantity = 1;
    this.value.push(billing);
    setTimeout(() => {
      this.selectedIndex = this.value.length - 1;
    }, 50);
  }

  deleteBilling(index: number) {
    this.value.splice(index, 1);
     setTimeout(() => {
      this.selectedIndex = index - 1;
    }, 50);
  }

  save() {
    const unchangedBillings: Array<Billing> = JSON.parse(this.pristineValue);
    const deletedBillings: Array<Billing> = unchangedBillings.filter((x) => !this.value.some((a) => x.BillingId == a.BillingId));
    const billingPromises: Array<Promise<void>> = [];
    const arbPromises: Array<Promise<ArbCommandResultDto>> = [];

    this._billingComponents.forEach((component) => {
      billingPromises.push(component.save(this.profileId));
    });

    for (const billing of deletedBillings) {
      if (billing.IsARB && billing.ARBID && billing.ARBID > 0) {
        arbPromises.push(this._arbService.cancelArbByBillingId(billing.BillingId));
      }
      billingPromises.push(this._billingService.deleteBilling(billing.BillingId));
    }

    if (arbPromises.length > 0) {
      return Promise.all(arbPromises).then(() => {
        return Promise.all(billingPromises).then(() => {
          this.setPristine();
        });
      });
    } else {
      return Promise.all(billingPromises).then(() => {
        this.setPristine();
      });
    }
  }

  loadBillings() {
    if (this.profileId) {
      this.loading = true;
      this._profileService
        .getProfileBillings(this.profileId, true, this.showInactive)
        .then((data) => {
          if (this.showInactive) {
            data = data.filter((x) => x.Inactive);
          }
          this.value = data;
          this.setPristine();
        })
        .catch((err) => {
          this._notificationService.httpError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  toggleInactiveView() {
    this.showInactive = !this.showInactive;
    this.loadBillings();
  }
}
